<button class="btn btn-info btn-block" (click)="openPreviewWindow();" type="button">Preview</button>